import { useCallback, useMemo, useState } from 'react';
import { type ReportEvent } from '@/types/report';

interface UseReportEventEditingResult {
    editingEventId: string | undefined;
    editingEvent: ReportEvent | undefined;
    requestEdit: (eventId: string) => void;
    closeEdit: () => void;
}

export function useReportEventEditing(
    events: ReportEvent[] | undefined,
): UseReportEventEditingResult {
    const [editingEventId, setEditingEventId] = useState<string | undefined>();

    const editingEvent = useMemo((): ReportEvent | undefined => {
        if (!editingEventId || !events) {
            return undefined;
        }
        return events.find((event) => event.id === editingEventId);
    }, [editingEventId, events]);

    const requestEdit = useCallback((eventId: string) => {
        setEditingEventId(eventId);
    }, []);

    const closeEdit = useCallback(() => {
        setEditingEventId(undefined);
    }, []);

    return { editingEventId, editingEvent, requestEdit, closeEdit };
}
